import { accessible, Accessible } from "./AccessibleStore";

export enum MapStoreEventType {
    UPDATE = 1,
    DELETE = 2,
}

export type MapStoreEvent = {
    type: MapStoreEventType,
    key: string,
    value?: any,
}

export class MapStore {
    private _store: Accessible<{[key: string]: any}>;
    private _afterEvent: Accessible<MapStoreEvent|undefined>;
    public get afterEvent() { return this._afterEvent; }
    constructor() {
        this._store = accessible({});
        this._afterEvent = accessible(undefined);
    }

    public set(key: string, value: any) {
        this._store.getValue()[key] = value;
        this._store.set(this._store.getValue());
        this._afterEvent.set({type: MapStoreEventType.UPDATE, key: key, value: value});
    }
    
    public get(key: string) {
        return this._store.getValue()[key];
    }

    public delete(key: string) {
        delete this._store.getValue()[key];
        this._store.set(this._store.getValue());
        this._afterEvent.set({type: MapStoreEventType.DELETE, key: key});
    }
}

